import { HEADER_HEIGHT } from "@src/modules/App/Topbar/Topbar.components";
import styled from "styled-components";

export const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: ${HEADER_HEIGHT}px;
`;
